import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d183f39"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d183f39')) {
      api.createRecord('6d183f39', component.options)
    } else {
      api.reload('6d183f39', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6d183f39", function () {
      api.rerender('6d183f39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/index.vue"
export default component.exports